/**
 * Archived / legacy threads not shown in the main inbox list.
 * Matched to the active visitor via visitorSessionId and identityEmails (skeleton).
 */
export const ARCHIVED_THREAD_STUBS = [
  {
    id: "arch-sarah-1",
    visitorSessionId: "vs_sess_sarah_001",
    identityEmails: ["sarah.johnson@acme.com"],
    startedAtLabel: "Mar 2, 2026",
    preview: "VAT receipt for last quarter — resolved via billing export.",
    status: "resolved",
    messageCount: 9,
    navigable: false,
  },
];
